import React, { useContext } from 'react';
import ResourceDisplay from 'field/display/ResourceDisplay';
import Predicates from 'constants/predicates';
import Form from 'react-bootstrap/Form';
import Header from 'field/common/Header';
import LocaleContext from 'constants/localization';
import SearchLink, { isSearchLink } from 'field/display/resource/SearchLink';

export default function ActorInverseDisplay({ field, mode, shaded }) {
  const LS = useContext(LocaleContext);

  // SPEC-365
  if (isSearchLink(field)) {
    return <SearchLink field={field} />;
  }

  const roles = new Set();
  const objects = [];

  for (let value of field.values) {
    for (let field of value.fields) {
      if (field.predicate === Predicates.SPECTRUM.ROLE) {
        roles.add(field.values[0]);
      }
      else if (field.predicate === Predicates.SPECTRUM.GENERAL_ACTOR_ROLE_INVERSE) {
        objects.push(field);
      }
    }
  }

  const Roles = () => {
    const rolesArray = Array.from(roles);
    if (rolesArray.length < 1) {
      return null;
    }

    return (
      <div className='resource row'>
        <Form.Label className='field-header'>{LS.roles}</Form.Label>
        <ul>
          {
            Array.from(roles).map((r, k) => 
              <li key={k}>
                <span className='literal-value'>
                  {r}
                </span>
              </li>)
          }
        </ul>
      </div>
    );
  };

  return (
    <div style={{padding: '0 0.3rem'}}>
      <Roles />
      {
        objects?.length > 0 && <Header field={field} type='resource' />
      }
      {
        objects.map((o, k) =>
          <ResourceDisplay key={k} field={o} mode={mode} shaded={shaded} />)
      }
    </div>
  );
}